import React, { useEffect } from 'react';
import axios from 'axios';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import { Provider, useDispatch } from 'react-redux';
import store from './store/store'; // Import our Redux store
import { setCredentials, clearCredentials } from './store/authSlice'; // Import actions
import StartGame from './components/StartGame/StartGame';
import Scoreboard from './components/Scoreboard/Scoreboard';
import Main from './components/Main/Main';
import CreateUser from './components/CreateUser/CreateUser';
import HomeScreen from './components/HomeScreen/HomeScreen';
import AccountHome from './components/Account/AccountHome/AccountHome';
import Login from './components/Login/Login';
import ManageAccount from './components/Account/Manage_Account/ManageAccount';
import ChangeUserName from './components/Account/Manage_Account/ChangeUserName/ChangeUserName';
import ChangeNickName from './components/Account/Manage_Account/ChangeNickName/ChangeNickName';
import ChangePassword from './components/Account/Manage_Account/ChangePassword/ChangePassword';
import ChangeEmail from './components/Account/Manage_Account/ChangeEmail/ChangeEmail';
import PlayerStats from './components/Account/Acccount_Stats/PlayerStats';
import Leaderboard from './components/Leaderboard/Leaderboard';
import PlayerScoreBoard from './components/Account/Acccount_Stats/PlayerScoreBoard/PlayerScoreBoard';
import Lobby from './components/Lobby/Lobby';
import ForgotPassword from './components/ForgotPassword/ForgotPassword';
import ResetPassword from './components/ResetPassword/ResetPassword';
import InviteNotification from './components/Notification/InviteNotification';

// Redirect to login on 401 (expired/invalid token)
axios.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 401 && !error.config?.url?.includes('/api/c/login/')) {
            localStorage.removeItem('accessToken');
            localStorage.removeItem('refreshToken');
            localStorage.removeItem('username');
            store.dispatch(clearCredentials());
            window.location.href = '/login';
        }
        return Promise.reject(error);
    }
);

// This functional component handles the initialization and cleanup of Redux and local storage
const AppInitializer = () => {
    const dispatch = useDispatch();

    useEffect(() => {
        // Retrieve token from local storage
        const accessToken = localStorage.getItem('accessToken');
        const refreshToken = localStorage.getItem('refreshToken');

        if (accessToken) {
            const username = localStorage.getItem('username');
            // Set credentials in Redux store
            dispatch(setCredentials({
                username: username,
                accessToken: accessToken,
                refreshToken: refreshToken,
            }));
        } else {
            // Clear credentials if no token is found
            dispatch(clearCredentials());
        }

    }, [dispatch]);

    return null; // This component does not render anything
};

function App() {
    return (
        <Provider store={store}>
            <Router>
                <AppInitializer /> {/* Initialize state on app load */}
                <InviteNotification />
                <div className="App">
                    <Routes>
                        <Route path="/" element={<HomeScreen />} />
                        <Route path="/main" element={<Main />} />
                        <Route path="/createuser" element={<CreateUser />} />
                        <Route path="/startgame" element={<StartGame />} />
                        <Route path="/scoreboard" element={<Scoreboard />} />
                        <Route path="/scoreboard/:gameID" element={<Scoreboard />} />
                        <Route path="/accounthome" element={<AccountHome />} />
                        <Route path="/login" element={<Login />} />
                        <Route path="/manageaccount" element={<ManageAccount />} />
                        <Route path="/changeusername" element={<ChangeUserName />} />
                        <Route path="/changenickname" element={<ChangeNickName />} />
                        <Route path="/changepassword" element={<ChangePassword />} />
                        <Route path="/changeemail" element={<ChangeEmail />} />
                        <Route path="/seestats" element={<PlayerStats />} />
                        <Route path="/leaderboard" element={<Leaderboard />} />
                        <Route path="/seestats/playerscoreboard" element={<PlayerScoreBoard />} />
                        <Route path="/lobby/:lobbyID" element={<Lobby />} />
                        <Route path="/forgotpassword" element={<ForgotPassword />} />
                        <Route path="/resetpassword" element={<ResetPassword />} />
                        <Route path="*" element={<Navigate to="/" replace />} />
                    </Routes>
                </div>
            </Router>
        </Provider>
    );
}

export default App;